import axios from "axios";
import { SERVER_URL } from "../../../../config/env";
import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

const projectService = {
  /**
   * =========================================================
   * ✅ GET PROJECTS
   * =========================================================
   */
  async getProjects({ schoolyearId }) {
    const res = await axios.get(SERVER_URL + "bszplanner/projects", {
      params: {
        schoolyearId,
      },
      headers: authHeader(),
    });

    return res.data;
  },

  /**
   * =========================================================
   * ✅ CREATE PROJECT
   * =========================================================
   */
  async createProject(projectData) {
    const res = await axios.post(
      SERVER_URL + "bszplanner/projects",
      projectData,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ UPDATE PROJECT
   * =========================================================
   */
  async updateProject(projectData) {
    const res = await axios.put(
      SERVER_URL + `bszplanner/projects/${projectData.id}`,
      projectData,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ DELETE PROJECT
   * =========================================================
   */
  async deleteProject(projectId) {
    const res = await axios.delete(
      SERVER_URL + `bszplanner/projects/${projectId}`,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },
};

export default projectService;
